import React from "react";
import "./ag_grid_overlay.less";
import { CustomOverlayProps } from "ag-grid-react";
import { AG_GRID_OVERLAY_TYPES } from "@src/constants";

export type AgGridOverlayComponentProps = CustomOverlayProps & {
  loadingMessage?: string;
  noRowsMessage?: string;
  noMatchingRowsMessage?: string;
  exportingMessage?: string;
  defaultMessage?: string;
  customStyle?: React.CSSProperties;
};

const AgGridOverlay: React.FC<AgGridOverlayComponentProps> = (props) => {
  const {
    overlayType,
    loadingMessage,
    noRowsMessage,
    noMatchingRowsMessage,
    exportingMessage,
    defaultMessage,
    customStyle,
  } = props;

  function getMessage(): string {
    switch (overlayType) {
      case AG_GRID_OVERLAY_TYPES.LOADING:
        return loadingMessage || "Loading...";
      case AG_GRID_OVERLAY_TYPES.NO_ROWS:
        return noRowsMessage || "No Rows to show";
      case AG_GRID_OVERLAY_TYPES.NO_MATCHING_ROWS:
        return noMatchingRowsMessage || "No Rows to show";
      case AG_GRID_OVERLAY_TYPES.EXPORTING:
        return exportingMessage || "Exporting...";
      default:
        return defaultMessage || "No Rows to show";
    }
  }

  return (
    <div className="ag-grid-overlay" style={customStyle}>
      {getMessage()}
    </div>
  );
};

export default AgGridOverlay;
